export default class ShareButton {
	constructor(buttonDom) {
		this.dom = buttonDom;

		this.network = this.dom.getAttribute('data-social-network');
		this.contentTitle = this.dom.getAttribute('data-content-title') ? this.dom.getAttribute('data-content-title') : null;
		
		this.attachEvents(this.network);
	}

	attachEvents(network) {
		let networkFunctions = {
			"facebook": () => this.bindFacebook(),
			"twitter": () => this.bindTwitter(),
			"email": () => this.bindEmail(),
			"snapchat": () => this.bindSnapchat()
		}

		if( typeof networkFunctions[network] == 'function' ){
			// Snapchat binds itself, so just run the bindSnapchat() function to handle this before click events
			if( network == 'snapchat' )
				this.bindSnapchat();
			else
				this.dom.addEventListener('click', (e) => { 
                    networkFunctions[network](); 
                    e.preventDefault(); 
                    return false; 
                });
		}
		else
			console.error('Social Sharing: Failed to setup ' + network +' sharing buttons.');
	}

	generateQuery(params) {
		return Object.keys(params).map(key => key + '=' + params[key]).join('&');
	}

	bindFacebook() {
		let query = this.generateQuery({
			href: window.location
		});

		window.open('https://www.facebook.com/sharer.php?' + query, 'Share on Facebook', 'width=800,height=600', 'facebook');

		return true;
	}

	bindTwitter() {
		let query = this.generateQuery({
			url: window.location,
			text: this.contentTitle
		});

		window.open('https://twitter.com/share?' + query, 'Share on Twitter', 'width=600,height=400', 'facebook');

		return true;
	}

	bindEmail() {
		let query = this.generateQuery({
			subject: this.contentTitle,
			body: window.location
		});

		window.location.href = 'mailto:?' + query;

		return true;
	}

	bindSnapchat() {
		// Asynchronously load the Snapchat SnapKit SDK
		(function (d, s, id) {
			var js, sjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) return;
			js = d.createElement(s); js.id = id;
			js.src = "https://sdk.snapkit.com/js/v1/create.js";
			sjs.parentNode.insertBefore(js, sjs);
		}(document, 'script', 'snapkit-creative-kit-sdk'));

        // Attach click event to button on SDK loading in
        window.snapKitInit = function () {
            snap.creativekit.initalizeShareButtons(
                document.getElementsByClassName('pnap-snapchat-button')
            );
        };   

        // Attach click event to the button if the SDK is already loaded in
        if( typeof snap !== 'undefined' )
            snap.creativekit.initalizeShareButtons(
                document.getElementsByClassName('pnap-snapchat-button')
            );
	}
}